import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MessageService, ConfirmationService } from 'primeng/api';
import { Component, OnInit, Input, EventEmitter, Output, Inject } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { AlertService } from '@app/_services';
import * as moment from 'moment';
import { PrimeNGConfig } from 'primeng/api';
import { RUPropertiesStatusService } from '../ru-properties-status.service';
import { RUPropertiesStatus } from '../ru-properties-status';

@Component({
    selector: 'app-ru-properties-status',
    templateUrl: './ru-properties-status.component.html',
    styleUrls: ['./ru-properties-status.component.css'],
    providers: [MessageService, ConfirmationService],
    standalone: false
})
export class RUPropertiesStatusComponent implements OnInit {

	constructor(
		private primengConfig: PrimeNGConfig,
		private ruPropertiesStatusService: RUPropertiesStatusService,
		private alertService: AlertService,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private formBuilder: FormBuilder,
		@Inject(MAT_DIALOG_DATA) data: any) {
		this.formTitle = data.title,
			this.ruPropertiesStatus = data.ruPropertiesStatus,
			this.statuses = ruPropertiesStatusService.statuses;
	}

	@Input() ruPropertiesStatus: RUPropertiesStatus;
	@Output() doAdd = new EventEmitter<any>();
	@Output() doUpdate = new EventEmitter<any>();
	@Output() doDelete = new EventEmitter<any>();

	// data
	ruPropertiesStatusId: number;

	// forms
	form1: FormGroup;
	formLoading = false;
	formAlert: String;
	formTitle: String;

	statuses: any;

	validationMessages = {
		'ruPropertiesStatusId': [],
		'clusterId': [],
		'clusterActive': [],
		'externalUnitId': [],
		'unitId': [],
		'unitActive': [],
		'propertyId': [],
		'pUID': [],
		'rateActive': [],
		'rateId': [],
		'rateMarkup': [],
		'rateName': [],
		'rateNrOfPeople': [],
		'contentStatus': [],
		'aRIStatus': [],
		'srcData': [],
		
	};

	ngOnInit() {
		this.primengConfig.ripple = true;
		this.formBuild();

		// if we were passed the whole ruPropertiesStatus object
		if (this.ruPropertiesStatus) {
			this.ruPropertiesStatusId = this.ruPropertiesStatus.ruPropertiesStatusId;
			this.fixDates();
			this.form1.patchValue(this.ruPropertiesStatus);
		}
	}

	onFormDelete() {
		console.log('onRowDelete: ' + JSON.stringify(event));
		this.confirmationService.confirm({
			message: 'Are you sure you want to delete Id# ' + this.ruPropertiesStatusId + '?',
			header: 'Confirm',
			icon: 'pi pi-exclamation-triangle',
			accept: () => {
				this.formDelete()
			},
			reject: () => {
				this.messageService.add({ severity: 'info', summary: 'Canceled', detail: 'Delete canceled.', life: 3000 });
			}
		});
	}

	formAdd() {
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			console.log('property-add post: ' + JSON.stringify(this.form1.value));
			this.formLoading = true;
			this.ruPropertiesStatusService.add(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-add SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ruPropertiesStatus = res.data.ruPropertiesStatus;
						this.doAdd.emit(this.ruPropertiesStatus);
					},
					(err: any) => {
						console.log('ruPropertiesStatus-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });

		} catch (error) {
			this.alertService.error(error);
		}
	}

	formUpdate() {
		console.log('ruPropertiesStatus: ' + JSON.stringify(this.form1.value));
		try {
			// stop here if form is invalid
			this.form1.markAllAsTouched();
			if (this.form1.invalid) {
				return;
			}
			this.formLoading = true;

			this.ruPropertiesStatusService.update(this.form1.value)
				.subscribe(
					(res: any) => {
						console.log('property-update SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.ruPropertiesStatus = res.data.ruPropertiesStatus;
						this.doUpdate.emit(this.ruPropertiesStatus);
					},
					(err: any) => {
						console.log('property-update FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			console.log('Form Invalid: ' + JSON.stringify(error));
			this.alertService.error(error);
		}
	}

	formDelete() {
		try {
			this.ruPropertiesStatusService.delete(this.ruPropertiesStatus.ruPropertiesStatusId)
				.subscribe(
					(res: any) => {
						console.log('ruPropertiesStatus-delete SUCCESS: ' + JSON.stringify(res));
						this.messageService.add({ severity: 'success', summary: 'Success', detail: res.message });
						this.doDelete.emit(this.ruPropertiesStatus);
					},
					(err: any) => {
						console.log('ruPropertiesStatus-add FAIL: ' + JSON.stringify(err));
						this.alertService.error(err);
					},
					() => { this.formLoading = false; });
		} catch (error) {
			this.alertService.error(error);
		}
	}

	formBuild() {
		this.form1 = this.formBuilder.group({
			ruPropertiesStatusId: [this.ruPropertiesStatusId],
			clusterId: [],
			clusterActive: [],
			externalUnitId: [],
			unitId: [],
			unitActive: [],
			propertyId: [],
			pUID: [],
			rateActive: [],
			rateId: [],
			rateMarkup: [],
			rateName: [],
			rateNrOfPeople: [],
			contentStatus: [],
			aRIStatus: [],
			srcData: [],
		});
	}

	fixDates() {
		// create date objects - why can't primeng do this?
		this.ruPropertiesStatus.ruPropertiesStatusDate = moment(this.ruPropertiesStatus.ruPropertiesStatusDate).toDate();
	}
}
